<button
  (click)="handleDropdownToggle()"
  type="button"
  class="flex items-center gap-sm rounded-full text-sm"
  id="user-menu-button"
  aria-expanded="false"
  aria-haspopup="true">
  <lib-avatar
    [fullName]="userName()"
    [img]="userImage() ?? ''"
    [imgClass]="'size-8! rounded-full'" />

  <div class="flex flex-col text-start">
    <div
      class="text-sm text-neutral-700 font-medium"
      role="menuitem"
      tabindex="-1">
      {{ userName() }}
    </div>

    @if (selectedWorkspace()) {
      <div class="text-xs text-neutral-500 font-normal uppercase">
        {{ selectedWorkspace()?.name || selectedWorkspace()?.slug }}
      </div>
    }
  </div>

  <lib-chevron-down-icon
    [iconClass]="
      'size-5 text-neutral-500' +
      (isOpen() ? ' rotate-180 me-x-sm' : ' ms-x-sm')
    " />
</button>
